export const FRONTEND_ERROR_CODE = '0000000000000000000000042';
